import { Observable } from 'rxjs'
import { Action } from 'actions'
import { FormNameType } from 'interfaces/form'
import { isFormSubmittedAction } from 'helpers/actionsHelpers'
import { byType } from 'rxOperators/byType'
import { FORM_SUBMITTED_SUCCESSFULLY, FORM_STOP_SUBMIT } from 'actions/formActions'
import { filter } from 'rxjs/operators'

export const formSubmitted = (...formTypes: FormNameType[]) => (source: Observable<Action>) => {
  const checker = isFormSubmittedAction(...formTypes)

  return source
    .pipe(
      byType(FORM_SUBMITTED_SUCCESSFULLY),
      // we should do it this, other way TS infers Action but not FormSubmittedSuccessfully here
      // tslint:disable-next-line:no-unnecessary-callback-wrapper
      filter((a) => checker(a)),
    )
}

export const formSubmitFailed = (...formTypes: FormNameType[]) => (source: Observable<Action>) => {
  const formTypeSet = new Set(formTypes)

  return source
    .pipe(
      byType(FORM_STOP_SUBMIT),
      // 'a.payload' contains errors -> 'a.payload !== undefined' means has errors
      filter((a) => a.payload !== undefined && (formTypes.length === 0 || formTypeSet.has(a.meta.form))),
    )
}
